import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  makeStyles,
  Typography,
  Grid,
  FormHelperText,
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  Radio,
  TableBody,
  TextField,
  Button,
} from "@material-ui/core/";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import { useSelector, useDispatch } from "react-redux";
import {
  getTerms,
  getClasses,
  clearErrorStatusCode,
  saveAttedance,
  clearErrorMessage,
} from "../../../reduxSlices/attendaceSlice";
import Backdrop from "../../Backdrop";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import localizedStrings from "../../../utils/localize";
import Aux from "../../../hoc/Auxilliary";
const useStyle = makeStyles((theme) => ({
  heading: {
    fontSize: "1.8rem",
    fontWeight: 500,
  },
  formDesignMain: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    minHeight: "60vh",
    marginTop: "1rem",
  },
  formDesign: {
    width: "97%",
    margin: "0 auto",
  },
  formControl: {
    margin: theme.spacing(1),
    maxWidth: "30%",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const Attendance = (props) => {
  const dispatch = useDispatch();
  const classes = useStyle(props);
  const [term, setTerms] = useState(0);
  const [classDate, setClassDate] = useState(0);
  const [className, setClassName] = useState(0);
  const [attendancesData, setAttendancesData] = useState([]);
  const [displayMessage, setDisplayMessage] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const termsData = useSelector((state) => state.attendanceData.term);
  const classNameData = useSelector((state) => state.attendanceData.className);
  const classDateData = useSelector((state) => state.attendanceData.classDate);
  const attendanceData = useSelector(
    (state) => state.attendanceData.attendance,
  );
  const applicantData = useSelector(
    (state) => state.applicationData.applicantStatus.ses_applicantstatus,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.attendanceData.dataFetchingStatus,
  );
  const errorMessage = useSelector(
    (state) => state.attendanceData.errorMessage,
  );
  const errorStatusCode = useSelector(
    (state) => state.attendanceData.errorStatusCode,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleChange = (event) => {
    if (event.target.value) {
      if (event.target.name === "term") {
        setClassName(0);
        setClassDate(0);
        setTerms(event.target.value);
      } else if (event.target.name === "className") {
        setClassDate(0);
        setClassName(event.target.value);
      } else if (event.target.name === "classDate") {
        setClassDate(event.target.value);
        setAttendancesData([]);
      }
    }
  };
  useEffect(() => {
    setAttendancesData(attendanceData);
  }, [attendanceData]);
  useEffect(() => {
    if (applicantData) {
      dispatch(
        getTerms({
          applicantId: applicantData.ses_applicantid,
          type: "attendance",
        }),
      );
    }
  }, [applicantData]);
  useEffect(() => {
    if (term !== 0) {
      dispatch(
        getClasses({
          query: "className",
          applicantId: applicantData.ses_applicantid,
          termId: term,
          type: "attendance",
        }),
      );
    }
  }, [term]);
  useEffect(() => {
    if (className !== 0) {
      dispatch(
        getClasses({
          query: "classDate",
          classId: className,
        }),
      );
    }
  }, [className]);
  useEffect(() => {
    if (classDate !== 0) {
      dispatch(
        getClasses({
          query: "attendance",
          classDateId: classDate,
          classId: className,
          applicantId: applicantData.ses_applicantid,
          termId: term,
        }),
      );
    }
  }, [classDate]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  const handleChanges = (event, index) => {
    if (event.target.name === "ses_attendancestatus") {
      const status = event.target.value;
      setAttendancesData((prev) => {
        const arr = [...prev];
        const obj = { ...arr[index], ses_attendancestatus: +status };
        arr[index] = obj;
        return arr;
      });
    } else if (event.target.name === "ses_remarks") {
      const remark = event.target.value;
      setAttendancesData((prev) => {
        const arr = [...prev];
        const obj = { ...arr[index], ses_remarks: remark };
        arr[index] = obj;
        return arr;
      });
    }
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleAttendanceSave = () => {
    dispatch(
      saveAttedance(
        attendancesData.map((atten) =>
          !atten.ses_attendancestatus
            ? { ...atten, ses_attendancestatus: 284210000 }
            : atten,
        ),
      ),
    );
  };
  let tableData = "";

  if (attendancesData.length > 0) {
    tableData = attendancesData.map((attendace, index) => (
      <StyledTableRow key={index}>
        <StyledTableCell component="th" scope="row">
          {" "}
          {attendace.ses_studentname}{" "}
        </StyledTableCell>
        <StyledTableCell align="center">
          {" "}
          {attendace.ses_institutionstudentid}{" "}
        </StyledTableCell>
        <StyledTableCell align="center">
          <Radio
            checked={
              attendace.ses_attendancestatus === 284210000
                ? true
                : (attendace.ses_attendancestatus === 284210002) === false &&
                  (attendace.ses_attendancestatus === 284210003) === false &&
                  (attendace.ses_attendancestatus === 284210001) === false
            }
            onChange={(event) => handleChanges(event, index)}
            value="284210000"
            color="default"
            name="ses_attendancestatus"
          />
        </StyledTableCell>
        <StyledTableCell align="center">
          <Radio
            checked={attendace.ses_attendancestatus === 284210001}
            onChange={(event) => handleChanges(event, index)}
            value="284210001"
            color="default"
            name="ses_attendancestatus"
          />
        </StyledTableCell>
        <StyledTableCell align="center">
          <Radio
            checked={attendace.ses_attendancestatus === 284210002}
            onChange={(event) => handleChanges(event, index)}
            value="284210002"
            color="default"
            name="ses_attendancestatus"
          />
        </StyledTableCell>
        <StyledTableCell align="center">
          <Radio
            checked={attendace.ses_attendancestatus === 284210003}
            onChange={(event) => handleChanges(event, index)}
            value="284210003"
            color="default"
            name="ses_attendancestatus"
          />
        </StyledTableCell>
        <StyledTableCell align="center">
          <TextField
            onChange={(event) => handleChanges(event, index)}
            id="standard-basic"
            name="ses_remarks"
            value={attendace.ses_remarks}
          />
        </StyledTableCell>
      </StyledTableRow>
    ));
  }
  useEffect(() => {
    if (error.message === "Attendance updated") {
      setDisplayMessage(localizedStrings.general.saveAttedancemessage);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Invalid request") {
      setDisplayMessage(localizedStrings.general.invalidRequest);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid container item className={classes.formDesignMain}>
        <Typography component="div" className={classes.heading}>
          {localizedStrings.facultyAndStuff.attendance.heading}
        </Typography>
        <FormControl className={classes.formControl}>
          <InputLabel id="term">
            {localizedStrings.facultyAndStuff.attendance.term}
          </InputLabel>
          <Select
            labelId="term"
            id="term"
            value={term}
            name="term"
            onChange={handleChange}
            disabled={!applicantData}
          >
            <MenuItem value={0}>
              <em>{localizedStrings.facultyAndStuff.attendance.selectOne} </em>
            </MenuItem>
            {termsData.length > 0
              ? termsData.map((el) => (
                  <MenuItem value={el.ses_termid}>{el.ses_termname}</MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        {term !== 0 ? (
          <FormControl className={classes.formControl}>
            <InputLabel id="className">
              {localizedStrings.facultyAndStuff.attendance.className}{" "}
            </InputLabel>
            <Select
              labelId="className"
              id="className"
              value={className}
              name="className"
              onChange={handleChange}
            >
              <MenuItem value={0}>
                <em>{localizedStrings.facultyAndStuff.attendance.selectOne}</em>
              </MenuItem>
              {classNameData.length > 0 ? (
                classNameData.map((classData) => (
                  <MenuItem value={classData.ses_classid}>
                    {classData.ses_coursename}
                  </MenuItem>
                ))
              ) : (
                <FormHelperText>
                  {localizedStrings.facultyAndStuff.attendance.NoClassNameMsg}{" "}
                </FormHelperText>
              )}
            </Select>
          </FormControl>
        ) : null}
        {className !== 0 ? (
          <FormControl className={classes.formControl}>
            <InputLabel id="classDate">
              {localizedStrings.facultyAndStuff.attendance.classDates}{" "}
            </InputLabel>
            <Select
              labelId="classDate"
              id="classDate"
              value={classDate}
              name="classDate"
              onChange={handleChange}
            >
              <MenuItem value={0}>
                <em>{localizedStrings.facultyAndStuff.attendance.selectOne}</em>
              </MenuItem>
              {classDateData.length > 0 ? (
                classDateData.map((classDate) => (
                  <MenuItem value={classDate.ses_classdateid}>
                    {
                      classDate[
                        "ses_start@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                    -
                    {
                      classDate[
                        "ses_stop@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </MenuItem>
                ))
              ) : (
                <FormHelperText>
                  {localizedStrings.facultyAndStuff.attendance.noClassDatesMsg}{" "}
                </FormHelperText>
              )}
            </Select>
          </FormControl>
        ) : null}

        {classDate !== 0 ? (
          <>
            <TableContainer
              component={Paper}
              style={{ minHeight: "40vh", marginBottom: "10px" }}
            >
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .studentName
                      }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .institutionIdNo
                      }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .present
                      }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {localizedStrings.facultyAndStuff.attendance.table.tardy}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .unexcusedAbsent
                      }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .excusedAbsent
                      }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        localizedStrings.facultyAndStuff.attendance.table
                          .remarks
                      }
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tableData}</TableBody>
              </Table>
            </TableContainer>
            <Typography
              component="div"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "1rem",
                width: "100%",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                style={{ textTransform: "capitalize", marginRight: "0.5rem" }}
                onClick={handleAttendanceSave}
              >
                {localizedStrings.facultyAndStuff.attendance.save}
              </Button>
            </Typography>
          </>
        ) : null}
      </Grid>
    </Aux>
  );
};

export default withRouter(Attendance);
